import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { Input, Label, Spinner } from 'reactstrap'
import './VerificationInput.scss'

VerificationInput.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  loading: PropTypes.bool,
  length: PropTypes.number,

  onChange: PropTypes.func,
  onFulfilled: PropTypes.func,
}

VerificationInput.defaultProps = {
  type: 'text',
  value: '',
  loading: false,
  length: 6,

  onChange: null,
  onFulfilled: null,
}

function VerificationInput(props) {
  const { type, value, loading, length, onChange, onFulfilled } = props

  // Not allow null/undefined --> if it's the case, use empty string instead
  const displayedValue = value || ''

  // Don't support invalid length
  if (length < 0 || length > 10) return null

  // Only allow letters and numbers
  const handleChange = (e) => {
    const value = e.target.value
    const onlyLettersAndNumbersRegex = type === 'number'
      ? /[^0-9]/g
      : /[^a-z0-9]/gi
    const normalizedValue = value
      ? value.replace(onlyLettersAndNumbersRegex, '')
      : value

    if (onChange) {
      onChange(normalizedValue)
    }

    // Trigger onFulfilled callback when it reaches the length
    if (onFulfilled && normalizedValue.length === length) {
      onFulfilled(normalizedValue)
    }
  }

  const labelClass = classnames({
    'verification-input__label': true,
    'verification-input__label--loading': loading,
  })

  return (
    <div className="verification-input">
      <Input
        id="transparentInput"
        className="verification-input__input"
        value={displayedValue}
        maxLength={length}
        disabled={loading}
        onChange={handleChange}
        autoComplete="off"
        autoCorrect="off"
      />

      <Label for="transparentInput" className={labelClass}>
        <ul className="verification-input__letters">
          {Array.from(Array(length).keys()).map(index => (
            <li key={index}>
              {displayedValue[index] || <span>&ndash;</span>}
            </li>
          ))}
        </ul>

        {loading && (
          <div className="verification-input__loading">
            <Spinner color="light" size="sm" />
          </div>
        )}
      </Label>
    </div>
  )
}

export default VerificationInput